// import apiFetch from '../apiFetch'

export default function (token) {
  // return apiFetch({endPoint: `entity/${entityId}`, method: 'GET', body: null, token: token})
  return [{ id: '1' }, { id: '2' }]
}
